export const environment = {
  production: false,
  apiUrl: 'https://liquid-wallets-test.dev.liquidgroup.sg/api/au10tix',
  appName: 'liquidpay-au10tix-fe - Test'
};

